/* ============================================
   JU BAO Theme JavaScript
   ============================================ */

(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {

    /* ---- Sticky header shadow ---- */
    const header = document.querySelector('.site-header');
    if (header) {
      window.addEventListener('scroll', function () {
        header.style.boxShadow = window.scrollY > 0 ? '0 2px 12px rgba(0,0,0,.08)' : 'none';
      }, { passive: true });
    }

    /* ---- Product gallery thumbnails ---- */
    const thumbnails = document.querySelectorAll('.thumbnail');
    const mainImg = document.querySelector('.gallery-main img');
    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbnails.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        if (mainImg) {
          const fullSrc = this.dataset.fullSrc;
          const thumbImg = this.querySelector('img');
          if (fullSrc) {
            mainImg.src = fullSrc;
            if (thumbImg) mainImg.alt = thumbImg.alt;
          } else if (thumbImg) {
            mainImg.src = thumbImg.src;
            mainImg.alt = thumbImg.alt;
          }
        }
      });
    });

    /* ---- Quantity buttons ---- */
    function bindQtyButtons(selector) {
      document.querySelectorAll(selector).forEach(function (btn) {
        btn.addEventListener('click', function () {
          const input = this.parentElement.querySelector('input');
          if (!input) return;
          let val = parseInt(input.value, 10) || 1;
          if (this.dataset.action === 'minus') {
            val = Math.max(1, val - 1);
          } else {
            val++;
          }
          input.value = val;
          // Trigger cart update for cart page
          const updateEvent = new Event('qty-change', { bubbles: true });
          input.dispatchEvent(updateEvent);
        });
      });
    }
    bindQtyButtons('.qty-btn');
    bindQtyButtons('.cart-qty-btn');

    /* ---- Product tabs ---- */
    const tabBtns = document.querySelectorAll('.tab-btn');
    tabBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        const target = this.dataset.tab;
        document.querySelectorAll('.tab-btn').forEach(function (b) { b.classList.remove('active'); });
        document.querySelectorAll('.tab-content').forEach(function (c) { c.classList.remove('active'); });
        this.classList.add('active');
        const pane = document.getElementById(target);
        if (pane) pane.classList.add('active');
      });
    });

    /* ---- Cart remove items ---- */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.cart-remove-btn');
      if (!btn) return;
      const item = btn.closest('.cart-item');
      if (item) {
        item.style.transition = 'opacity .3s, max-height .3s';
        item.style.opacity = '0';
        setTimeout(function () { item.remove(); }, 320);
      }
    });

    /* ---- Add to cart feedback ---- */
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.btn-add-to-cart, .btn-add-to-cart-sm');
      if (!btn) return;
      const orig = btn.innerHTML;
      btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg> Added!';
      btn.style.background = '#4CAF50';
      setTimeout(function () {
        btn.innerHTML = orig;
        btn.style.background = '';
      }, 1600);
    });

    /* ---- Newsletter & footer email form ---- */
    document.querySelectorAll('.newsletter-form, .footer-email-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        const input = this.querySelector('input[type="email"]');
        const btn = this.querySelector('button');
        if (input && input.value.trim()) {
          input.value = '';
          if (btn) {
            const orig = btn.textContent;
            btn.textContent = 'Subscribed!';
            btn.style.background = '#4CAF50';
            setTimeout(function () {
              btn.textContent = orig;
              btn.style.background = '';
            }, 2200);
          }
        }
      });
    });

    /* ---- Coupon apply button ---- */
    const couponBtn = document.querySelector('.coupon-apply');
    if (couponBtn) {
      couponBtn.addEventListener('click', function () {
        const input = document.querySelector('.coupon-input');
        if (input && input.value.trim()) {
          const orig = this.textContent;
          this.textContent = 'Applied!';
          this.style.background = '#4CAF50';
          this.style.color = '#fff';
          this.style.borderColor = '#4CAF50';
          setTimeout(function () {
            couponBtn.textContent = orig;
            couponBtn.style.background = '';
            couponBtn.style.color = '';
            couponBtn.style.borderColor = '';
          }, 2000);
        }
      });
    }

    /* ---- Mobile nav toggle ---- */
    const navToggle = document.querySelector('.nav-toggle');
    const mobileNav = document.querySelector('.site-nav');
    if (navToggle && mobileNav) {
      navToggle.addEventListener('click', function () {
        mobileNav.classList.toggle('nav-open');
      });
    }

    /* ---- Variant selector ---- */
    var variantBtns = document.querySelectorAll('.variant-option-btn');
    if (variantBtns.length > 0) {
      var variantsData = JSON.parse(document.getElementById('product-variants-json').textContent);
      var selectedOptions = {};

      document.querySelectorAll('.variant-selector-group').forEach(function (group) {
        var activeBtn = group.querySelector('.variant-option-btn.active');
        if (activeBtn) {
          selectedOptions[activeBtn.dataset.optionIndex] = activeBtn.dataset.value;
        }
      });

      // Cache the SVG icon HTML from the add-to-cart button so we can restore it
      var addBtn = document.querySelector('.btn-add-to-cart');
      var addToCartHTML = addBtn ? addBtn.innerHTML : 'Add to Cart';

      function findVariant() {
        var keys = Object.keys(selectedOptions);
        if (keys.length === 0) return null;
        return variantsData.find(function (v) {
          return keys.every(function (idx) {
            return v['option' + (parseInt(idx) + 1)] === selectedOptions[idx];
          });
        });
      }

      function variantIsAvailable(optionIndex, optionValue) {
        // Check if there is ANY available variant with the given option value
        // that also matches the currently selected values for OTHER option groups
        return variantsData.some(function (v) {
          if (!v.available) return false;
          if (v['option' + (parseInt(optionIndex) + 1)] !== optionValue) return false;
          return Object.keys(selectedOptions).every(function (idx) {
            if (idx === optionIndex) return true;
            return v['option' + (parseInt(idx) + 1)] === selectedOptions[idx];
          });
        });
      }

      function refreshOptionAvailability() {
        variantBtns.forEach(function (btn) {
          var idx = btn.dataset.optionIndex;
          var val = btn.dataset.value;
          if (variantIsAvailable(idx, val)) {
            btn.classList.remove('variant-unavailable');
            btn.disabled = false;
          } else {
            btn.classList.add('variant-unavailable');
          }
        });
      }

      function updateVariantUI(variant) {
        if (!variant) return;
        document.getElementById('variant-id').value = variant.id;
        var priceEl = document.querySelector('.product-price');
        if (priceEl && variant.price) {
          var currency = (window.Shopify && Shopify.currency) ? Shopify.currency.active : 'USD';
          priceEl.textContent = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
        }
        var buyNow = document.querySelector('.btn-buy-now');
        if (buyNow) {
          buyNow.href = '/checkout?variant=' + variant.id + '&quantity=1';
          buyNow.style.display = variant.available ? '' : 'none';
        }
        if (addBtn) {
          if (variant.available) {
            addBtn.disabled = false;
            addBtn.innerHTML = addToCartHTML;
          } else {
            addBtn.disabled = true;
            addBtn.innerHTML = 'Sold Out';
          }
        }
        if (variant.featured_image) {
          var mainImg = document.querySelector('.gallery-main img');
          if (mainImg) mainImg.src = variant.featured_image.src;
        }
      }

      // Sync UI to the initially selected variant on page load
      var initialVariant = findVariant();
      if (initialVariant) {
        updateVariantUI(initialVariant);
      }
      refreshOptionAvailability();

      variantBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = this.dataset.optionIndex;
          document.querySelectorAll('.variant-option-btn[data-option-index="' + idx + '"]').forEach(function (b) {
            b.classList.remove('active');
          });
          this.classList.add('active');
          selectedOptions[idx] = this.dataset.value;
          refreshOptionAvailability();
          updateVariantUI(findVariant());
        });
      });
    }

  });
})();
